// extracted by mini-css-extract-plugin
module.exports = {"breadCrumbs":"SearchAudioBooksView__breadCrumbs"};